import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraOverlayDialog, SpecraTimeline } from '@mono/ui-components/captains';
import { SpecraBadge, SpecraButton } from '@mono/ui-components/ensigns';
import { SpecraInlineBanner, SpecraOverlayFooter } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { useIntelClaimAudienceHistory } from './hooks';
export const directionLabel = {
    CREATED: 'Created',
    WIDENED: 'Shared more widely',
    NARROWED: 'Narrowed',
    CHANGED: 'Changed'
};
const directionVariant = (d)=>d === 'WIDENED' ? 'info' : d === 'NARROWED' ? 'warning' : 'neutral';
const formatDateTime = (d)=>d ? d.toLocaleString('en-US', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit'
    }) : '';
/** Every audience change on one claim. Only the author's response carries names inside past audiences. */ export function AudienceHistoryDialog({ claimId, open, onOpenChange }) {
    const history = useIntelClaimAudienceHistory(claimId, open);
    const changes = history.data ?? [];
    return /*#__PURE__*/ _jsxs(SpecraOverlayDialog, {
        open: open,
        onOpenChange: onOpenChange,
        size: "sm",
        title: "Who could see this, over time",
        testId: Testids.registryHearsay.audienceHistory,
        children: [
            history.isError ? // A failed audit read must never look like an empty history.
            /*#__PURE__*/ _jsx(SpecraInlineBanner, {
                tone: "danger",
                variant: "framed",
                action: /*#__PURE__*/ _jsx(SpecraButton, {
                    variant: "outline",
                    size: "sm",
                    onClick: ()=>void history.refetch(),
                    children: "Retry"
                }),
                children: "Couldn't load who could see this."
            }) : /*#__PURE__*/ _jsx(SpecraTimeline, {
                variant: "rail",
                emptyText: history.isPending ? 'Loading…' : 'No changes recorded.',
                items: changes.map((c)=>({
                        id: c.audienceId,
                        title: c.summary,
                        date: formatDateTime(c.changedAt),
                        description: `${c.changedByName}${c.note ? ` · ${c.note}` : ''}`,
                        badge: /*#__PURE__*/ _jsx(SpecraBadge, {
                            variant: directionVariant(c.direction),
                            children: directionLabel[c.direction]
                        })
                    }))
            }),
            /*#__PURE__*/ _jsx(SpecraOverlayFooter, {
                confirmLabel: "Close",
                onConfirm: ()=>onOpenChange(false)
            })
        ]
    });
}
